<template>
  <div class="main confirm" v-loading="isLoading">
    <div>
      <span>{{ $t('prices-confirm-title1') }}：</span>
      <span class="blue">{{username}}({{account}})</span>
    </div>
    <div>
      <span>{{ $t('prices-confirm-title2') }}：</span>
      <span class="blue">{{paymentPlan}}</span>
    </div>
    <div>
      <span>{{ $t('prices-confirm-title3') }}：</span>
      <span class="blue">{{totalPrice}}</span>
    </div>
    <div>
      <span>{{ $t('prices-confirm-title4') }}：</span>
      <span class="blue">{{paymentWayTransfer}}</span>
    </div>
    <div id="pay" @click="pay">{{ $t('prices-confirm-title5') }}</div>
    <div class="payment-dialog" v-show="isPaying">
      <div class="dialog-main">
        <div class="blue">{{ $t('prices-confirm-title6') }}</div>
        <div class="tip">{{ $t('prices-confirm-title7') }}</div>
        <div class="payment-result">
          <span class="unComplete" @click="pay">{{ $t('prices-confirm-title8') }}</span>
          <span class="complete" @click="paySuccessfully">{{ $t('prices-confirm-title9') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import state from '../../assets/js/state'
//  import bus from '../../assets/js/EventBus'
  export default {
    data () {
      return {
        account: '',
        paymentPlan: '',
        totalPrice: '',
        paymentWay: '',
        comeFromPaymentPage: false,
        isPaying: false,
        productId: '',
        isLoading: false,
        username: ''
      }
    },
    computed: {
      paymentWayTransfer () {
        return this.paymentWay === '0' ? 'PayPal' : ''
      }
    },
    mounted () {
      this.getOrderList()
//      let that = this
//      bus.$on('passParams', function (params) {
//        that.account = params.account
//        that.paymentPlan = params.paymentPlan
//        that.totalPrice = params.totalPrice
//        that.paymentWay = params.paymentWay
//        that.comeFromPaymentPage = params.comeFromPaymentPage
//      })
//      setTimeout(() => {
//        if (!this.comeFromPaymentPage) {
//          this.$router.push('/Prices/Payment')
//        }
//      }, 500)
    },
    methods: {
      getOrderList () {
        this.$axios.post('/proxy-api/client/pay/orders/get-orders-by-id', this.qs.stringify({
          order_id: state.getData().orderId
        })).then(res => {
          if (res.data.status === '0') {
            this.account = state.getData().account
            this.username = state.getData().username
            this.paymentPlan = res.data.payload['order_info']['product_name']
            this.totalPrice = '$' + res.data.payload['order_info']['total_price']
            this.paymentWay = res.data.payload['order_info']['pay_method']
            this.productId = res.data.payload['order_info']['product_id']
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning',
              duration: 2000
            })
            this.$router.push('/Prices/Payment')
            return false
          }
        }).catch(err => {
          this.$message.error(this.$t('prices-confirm-title10'))
          console.log(err)
        })
      },
      pay () {
//        this.isPaying = true
        this.isLoading = true
        this.$axios.post('/proxy-api/client/pay/paypal/start-pay', this.qs.stringify({
          product_id: this.productId,
          order_id: state.getData().orderId,
          pay_method: this.paymentWay
        })).then(res => {
          console.log(res)
          if (res.data.status === '0') {
//            this.isLoading = false
            setTimeout(() => {
              this.isLoading = false
            }, 10000)
            window.location.href = res.data.payload.url
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning',
              duration: 2000
            })
            this.isLoading = false
            return false
          }
        }).catch(err => {
          this.isLoading = false
          this.$message.error(this.$t('prices-confirm-title10'))
          console.log(err)
        })
      },
      paySuccessfully () {
        this.isPaying = false
        this.$router.push('/Prices/Success')
      }
    }
  }
</script>
<style lang="scss" scoped>
  .confirm {
    width: 5rem;
    margin: 2.5rem auto 3.45rem !important;
    @media screen and (max-width: 760px){
      width: 3rem;
      margin: 1.85rem auto 2.45rem !important;
    }
    > div {
      margin-bottom: .15rem;
      font-size: .25rem;
      @media screen and (max-width: 760px){
        font-size: .2rem;
      }
    }
    .blue {
      color: #00a7ff;
    }
    #pay {
      width: 2rem;
      height: 0.5rem;
      line-height: 0.5rem;
      font-size: 0.2rem;
      background: #5CA4EC;
      border-radius: 3px;
      font-weight: 400;
      text-align: center;
      color: #fff;
      cursor: pointer;
      margin-top: .5rem;
    }
    .payment-dialog {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      position: fixed;
      z-index: 100;
      background: rgba(0, 0, 0, 0.2);
      .dialog-main {
        width: 5rem;
        height: 3rem;
        position: fixed;
        top: 50%;
        left: 50%;
        margin-left: -3.5rem;
        margin-top: -2rem;
        text-align: center;
        background: #fff;
        font-size: .2rem;
        padding: .5rem .8rem;
        @media screen and (max-width: 760px){
          margin-top: -2.2rem;
        }
        @media screen and (max-width: 760px){
          width: 3rem;
          height: 2.4rem;
          margin-left: -1.5rem;
          font-size: .15rem;
          padding: .5rem .3rem;
        }
        > div {
          margin-bottom: .3rem;
        }
        .tip {
          @media screen and (max-width: 760px){
            font-size: .14rem;
          }
        }
        .payment-result {
          margin-top: .5rem;
        }
        .unComplete {
          display: inline-block;
          vertical-align: middle;
          border:1px solid #00a7ff;
          color: #00a7ff;
          padding: .1rem .15rem;
          border-radius: 5px;
          cursor: pointer;
          @media screen and (max-width: 760px){
            padding: .06rem .15rem;
          }
        }
        .complete {
          display: inline-block;
          vertical-align: middle;
          background: #5CA4EC;
          color: #fff;
          padding: .11rem .15rem;
          border-radius: 5px;
          margin-left: .15rem;
          cursor: pointer;
          @media screen and (max-width: 760px){
            padding: .07rem .15rem;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Confirm.vue?96ad4122